/** 监管方权限 */
export enum ManagePermission {
  /**  ================================ '供方管理 ================================ '*/
  /** 查看供方 */
  SupplierView = 'supervisor:supplier-management:view-suppliers',
  /** 新建供方 */
  SupplierNew = 'supervisor:supplier-management:create-suppliers',
  /** 编辑供方 */
  SupplierEdit = 'supervisor:supplier-management:edit-suppliers',
  /** 审核供方 */
  SupplierAudit = 'supervisor:supplier-management:audit-suppliers',
  /** 启用供方 */
  SupplierEnable = 'supervisor:supplier-management:enable-suppliers',
  /** 禁用供方 */
  SupplierDisable = 'supervisor:supplier-management:disable-suppliers',
  /** 删除供方 */
  SupplierDelete = 'supervisor:supplier-management:delete-suppliers',
  /** 批量导入 */
  SupplierImport = 'supervisor:supplier-management:batch-import',
  /** 批量导出 */
  SupplierExport = 'supervisor:supplier-management:batch-export',
  /** 批量启用 */
  SupplierBatchEnable = 'supervisor:supplier-management:batch-enable',
  /** 批量禁用 */
  SupplierBatchDisable = 'supervisor:supplier-management:batch-disable',
  /** 批量删除 */
  SupplierBatchDelete = 'supervisor:supplier-management:batch-delete',
  /** 批量编辑 */
  SupplierBatchEdit = 'supervisor:supplier-management:batch-update-info',
  /** 登录供方 */
  SupplierLogin = 'supervisor:supplier-management:login-supplier',
  /** 绩效评分模板 */
  SupplierScoreTemp = 'supervisor:supplier-performance:performance-scoring-template',
  /** 批量手动评分 */
  SupplierBatchScore = 'supervisor:supplier-performance:batch-manual-scoring',
  /**  ================================ '需方管理 ================================ '*/
  /** 查看需方 */
  DemandView = 'supervisor:demander-management:view-demanders',
  /** 新建需方 */
  DemandNew = 'supervisor:demander-management:create-demanders',
  /** 编辑需方 */
  DemandEdit = 'supervisor:demander-management:edit-demanders',
  /** 审核需方 */
  DemandAudit = 'supervisor:demander-management:audit-demanders',
  /** 启用需方 */
  DemandEnable = 'supervisor:demander-management:enable-demanders',
  /** 禁用需方 */
  DemandDisable = 'supervisor:demander-management:disable-demanders',
  /** 删除需方 */
  DemandDelete = 'supervisor:demander-management:delete-demanders',
  /** 批量导入 */
  DemandImport = 'supervisor:demander-management:batch-import',
  /** 批量导出 */
  DemandExport = 'supervisor:demander-management:batch-export',
  /** 批量启用 */
  DemandBatchEnable = 'supervisor:demander-management:batch-enable-demanders',
  /** 批量禁用 */
  DemandBatchDisable = 'supervisor:demander-management:batch-disable-demanders',
  /** 批量删除 */
  DemandBatchDelete = 'supervisor:demander-management:batch-delete-demanders',
  /** 登录需方 */
  DemandLogin = 'supervisor:demander-management:login-demander',
  /** 批量编辑 */
  DemandBatchEdit = 'supervisor:demander-management:batch-update-info',
  /**  ================================ '需方组管理 ================================ '*/
  /** 新建需方组 */
  DemandGroupNew = 'supervisor:demander-group-management:create-demander-groups',
  /** 编辑需方组 */
  DemandGroupEdit = 'supervisor:demander-group-management:edit-demander-groups',
  /** 删除需方组 */
  DemandGroupDelete = 'supervisor:demander-group-management:delete-demander-groups',
  /** 批量删除 */
  DemandGroupBatchDelete = 'supervisor:demander-group-management:batch-delete',
  /** 查看需方组 */
  /**  ================================ '供方绩效 ================================ '*/
  /** 供方绩效启用供方 */
  SupplierPerformanceEnableSupplier = 'supervisor:supplier-performance:enable-suppliers',
  /** 供方绩效禁用供方 */
  SupplierPerformanceDisableSupplier = 'supervisor:supplier-performance:disable-suppliers',
  /** 供方绩效批量导出 */
  SupplierPerformanceBatchExport = 'supervisor:supplier-performance:batch-export',
  /** 供方绩效批量启用 */
  SupplierPerformanceBatchEnable = 'supervisor:supplier-performance:batch-enable',
  /** 供方绩效批量禁用 */
  SupplierPerformanceBatchDisable = 'supervisor:supplier-performance:batch-disable',
  /**  ================================ '商品列表 ================================ '*/
  /** 查看监管商品 */
  ProductView = 'supervisor:commodity-list:view-monitored-commodities',
  /** 新建监管商品 */
  ProductNew = 'supervisor:commodity-list:create-monitored-commodities',
  /** 编辑监管商品 */
  ProductEdit = 'supervisor:commodity-list:edit-monitored-commodities',
  /** 启用监管商品 */
  ProductEnable = 'supervisor:commodity-list:enable-monitored-commodities',
  /** 禁用监管商品 */
  ProductDisable = 'supervisor:commodity-list:disable-monitored-commodities',
  /** 删除监管商品 */
  ProductDelete = 'supervisor:commodity-list:delete-monitored-commodities',
  /** 批量导入 */
  ProductImport = 'supervisor:commodity-list:batch-import-monitored-commodities',
  /** 批量导出 */
  ProductExport = 'supervisor:commodity-list:batch-export-monitored-commodities',
  /** 批量启用 */
  ProductBatchEnable = 'supervisor:commodity-list:batch-enable-monitored-commodities',
  /** 批量禁用 */
  ProductBatchDisable = 'supervisor:commodity-list:batch-disable-monitored-commodities',
  /** 批量删除 */
  ProductBatchDelete = 'supervisor:commodity-list:batch-delete-monitored-commodities',
  /** 批量编辑 */
  ProductBatchEdit = 'supervisor:commodity-list:batch-update-info',
  /**  ================================ '商品分类列表 ================================ '*/
  /** 新建商品分类 */
  ProductCategoryNew = 'supervisor:commodity-category-list:create-commodity-categories',
  /** 编辑商品分类 */
  ProductCategoryEdit = 'supervisor:commodity-category-list:edit-commodity-categories',
  /** 删除商品分类 */
  ProductCategoryDelete = 'supervisor:commodity-category-list:delete-commodity-categories',
  /** 批量导入 */
  ProductCategoryImport = 'supervisor:commodity-category-list:export',
  /** [组合商品] */
  /** 组合商品查看 */
  CombinationProductView = 'supervisor:combined-commodity-management:view-combined-commodities',
  /** 组合商品新建 */
  CombinationProductCreate = 'supervisor:combined-commodity-management:create-combined-commodities',
  /** 组合商品编辑 */
  CombinationProductEdit = 'supervisor:combined-commodity-management:edit-combined-commodities',
  /** 组合商品启用 */
  CombinationProductEnable = 'supervisor:combined-commodity-management:enable-combined-commodities',
  /** 组合商品禁用 */
  CombinationProductDisEnable = 'supervisor:combined-commodity-management:disable-combined-commodities',
  /** 组合商品删除 */
  CombinationProductDelect = 'supervisor:combined-commodity-management:delete-combined-commodities',
  /** 组合商品批量导入 */
  CombinationProductBatchImport = 'supervisor:combined-commodity-management:batch-import',
  /** 组合商品批量导出 */
  CombinationProductBatchExport = 'supervisor:combined-commodity-management:batch-export',
  /** 组合商品批量启用 */
  CombinationProductBatchEnable = 'supervisor:combined-commodity-management:batch-enable',
  /** 组合商品批量禁用 */
  CombinationProductBatchDisEnable = 'supervisor:combined-commodity-management:batch-disable',
  /** 组合商品批量删除 */
  CombinationProductBatchDelect = 'supervisor:combined-commodity-management:batch-delete',
  /** 组合商品批量编辑 */
  CombinationProductBatchEdit = 'supervisor:combined-commodity-management:batch-update-info',
  /** [非监管商品] */
  /** 非监管商品查看 */
  ManageUnsuperviseCommodityView = 'supervisor:non-monitored-commodity-audit-list:view-commodities',
  /** 非监管商品审核 */
  ManageUnsuperviseCommodityReview = 'supervisor:non-monitored-commodity-audit-list:audit-commodities',
  /** 非监管商品批量审核 */
  ManageUnsuperviseCommodityBatchReview = 'supervisor:non-monitored-commodity-audit-list:batch-audit',
  /**  ================================ '用户管理 ================================ '*/
  /** 新建用户 */
  UserNew = 'supervisor:user-management:create-users',
  /** 编辑用户 */
  UserEdit = 'supervisor:user-management:edit-users',
  /** 修改密码 */
  UserEditPassword = 'supervisor:user-management:change-passwords',
  /** 启用用户 */
  UserEnable = 'supervisor:user-management:enable-users',
  /** 禁用用户 */
  UserDisable = 'supervisor:user-management:disable-users',
  /** 删除用户 */
  UserDelete = 'supervisor:user-management:delete-users',
  /** 批量启用 */
  UserBatchEnable = 'supervisor:user-management:batch-enable',
  /** 批量禁用 */
  UserBatchDisable = 'supervisor:user-management:batch-disable',
  /** 批量删除 */
  UserBatchDelete = 'supervisor:user-management:batch-delete',

  /**  ================================ '角色管理 ================================ '*/
  /** 新建角色 */
  RoleNew = 'supervisor:role-management:create-roles',
  /** 编辑角色 */
  RoleEdit = 'supervisor:role-management:edit-roles',
  /** 删除角色 */
  RoleDelete = 'supervisor:role-management:delete-roles',

  /**  ================================ '询价管理 ================================ '*/
  /** 查看询价单 */
  InquiryView = 'supervisor:inquiry-management:view-inquiry-orders',
  /** 编辑询价单 */
  InquiryEdit = 'supervisor:inquiry-management:edit-inquiry-orders',
  /** 发布询价单 */
  InquiryPublish = 'supervisor:inquiry-management:publish-inquiry-orders',
  /** 终止发布 */
  InquiryCancelPublish = 'supervisor:inquiry-management:suspend-inquiry-orders',
  /** 延期询价单 */
  InquiryDelay = 'supervisor:inquiry-management:extend-inquiry-orders',
  /** 比价定价 */
  InquiryCompare = 'supervisor:inquiry-management:compare-prices-and-set-prices',
  /** 复制询价单 */
  InquiryCopy = 'supervisor:inquiry-management:copy-inquiry-orders',
  /** 关闭询价单 */
  InquiryClose = 'supervisor:inquiry-management:close-inquiry-orders',
  /** 删除询价单 */
  InquiryDelete = 'supervisor:inquiry-management:delete-inquiry-orders',
  /** 批量发布 */
  InquiryBatchPublish = 'supervisor:inquiry-management:batch-publish',
  /** 批量终止 */
  InquiryBatchCancelPublish = 'supervisor:inquiry-management:batch-suspend',
  /** 批量延期 */
  InquiryBatchDelay = 'supervisor:inquiry-management:batch-extend',
  /** 批量关闭 */
  InquiryBatchClose = 'supervisor:inquiry-management:batch-close',
  /** 新增询价单 */
  InquiryNew = 'supervisor:inquiry-management:create-inquiry-orders',
  /** 询价单取消公示 */
  InquiryCancelPublic = 'supervisor:inquiry-management:update-cancel-public',
  /** 询价单公示 */
  InquiryPublic = 'supervisor:inquiry-management:update-public',
  /** 批量取消公示 */
  InquiryBatchCancelPublic = 'supervisor:inquiry-management:batch-update-cancel-public',
  /** 批量公示 */
  InquiryBatchPublic = 'supervisor:inquiry-management:batch-update-public',
  /** 批量询价 */
  InquiryBatchGenerate = 'supervisor:inquiry-management:batch-add-inquiry',
  /**  ================================ '报价管理 ================================ '*/
  /** 查看报价单 */
  QuoteView = 'supervisor:quotation-management:view-quotation-orders',
  /** 新建报价单 */
  QuoteNew = 'supervisor:quotation-management:create-quotation-orders',
  /** 编辑报价单 */
  QuoteEdit = 'supervisor:quotation-management:edit-quotation-orders',
  /** 锁定报价单 */
  QuoteLock = 'supervisor:quotation-management:lock-quotation-orders',
  /** 解锁报价单 */
  QuoteUnlock = 'supervisor:quotation-management:unlock-quotation-orders',
  /** 生产采购合同 */
  QuoteContract = 'supervisor:quotation-management:generate-purchase-contracts',
  /** 复制报价单 */
  QuoteCopy = 'supervisor:quotation-management:copy-quotation-orders',
  /** 删除报价单 */
  QuoteDelete = 'supervisor:quotation-management:delete-quotation-orders',
  /** 批量锁定报价单 */
  QuoteBatchLock = 'supervisor:quotation-management:batch-lock-quotation-orders',
  /** 批量解锁报价单 */
  QuoteBatchUnlock = 'supervisor:quotation-management:batch-unlock-quotation-orders',
  /** 批量删除报价单 */
  QuoteBatchDelete = 'supervisor:quotation-management:batch-delete-quotation-orders',
  /** 批量改价 */
  QuoteBatchModifyPrice = 'supervisor:quotation-management:batch-change-price',
  /**  ================================ '价格监控 ================================ '*/
  /** 批量导出 */
  MonitorBatchExport = 'supervisor:price-monitoring:batch-export',

  /**  ================================ '采购合同管理 ================================ '*/
  /** 查看采购合同 */
  ContractView = 'supervisor:purchase-contract-list:view-purchase-contracts',
  /** 新建采购合同 */
  ContractNew = 'supervisor:purchase-contract-list:create-purchase-contracts',
  /** 编辑采购合同 */
  ContractEdit = 'supervisor:purchase-contract-list:edit-purchase-contracts',
  /** 发布采购合同 */
  ContractPublish = 'supervisor:purchase-contract-list:publish-purchase-contracts',
  /** 复制采购合同 */
  ContractCopy = 'supervisor:purchase-contract-list:copy-purchase-contracts',
  /** 关闭采购合同 */
  ContractClose = 'supervisor:purchase-contract-list:close-purchase-contracts',
  /** 审核采购合同 */
  ContractAudit = 'supervisor:purchase-contract-list:publish-purchase-audit',
  /** 删除采购合同 */
  ContractDelete = 'supervisor:purchase-contract-list:delete-purchase-contracts',
  /** 批量发布 */
  ContractBatchPublish = 'supervisor:purchase-contract-list:batch-publish',
  /** 批量关闭 */
  ContractBatchClose = 'supervisor:purchase-contract-list:batch-close',
  /** 批量删除 */
  ContractBatchDelete = 'supervisor:purchase-contract-list:batch-delete',
  /** 批量改价 */
  ContractBatchModifyPrice = 'supervisor:purchase-contract-list:batch-change-price',
  /** 批量导出 */
  ContractBatchExport = 'supervisor:purchase-contract-list:publish-purchase-export',
  /** 批量审核 */
  ContractBatchAudit = 'supervisor:purchase-contract-list:publish-purchase-batch-audit',
  /**  ================================ '采购单管理 ================================ '*/
  /** 查看采购单 */
  PurchaseView = 'supervisor:purchase-order-management:view-purchase-orders',
  /** 审核采购单 */
  PurchaseAudit = 'supervisor:purchase-order-management:audit-purchase-orders',
  /** 编辑采购单 */
  PurchaseEdit = 'supervisor:purchase-order-management:edit-purchase-orders',
  /** 查看质检报价 */
  PurchaseCheck = 'supervisor:purchase-order-management:view-quality-inspection-reports',
  /** 查看收获记录 */
  PurchaseReceipt = 'supervisor:purchase-order-management:view-receipt-records',
  /** 批量审核 */
  PurchaseBatchAudit = 'supervisor:purchase-order-management:batch-audit',
  /** 批量改价 */
  PurchaseBatchEditPrice = 'supervisor:purchase-order-management:batch-change-prices',
  /** 批量导出 */
  PurchaseBatchExport = 'supervisor:purchase-order-management:batch-export',
  /** 新增采购单 */
  PurchaseNew = 'supervisor:purchase-order-management:create-purchase-orders',
  /** 补录采购单 */
  PurchaseRepair = 'supervisor:purchase-order-management:supplement-purchase',
  /** 复制采购单 */
  PurchaseCopy = 'supervisor:purchase-order-management:copy-purchase-orders',
  /** 关闭采购单 */
  PurchaseClose = 'supervisor:purchase-order-management:close-purchase-orders',
  /** 删除采购单 */
  PurchaseDelete = 'supervisor:purchase-order-management:delete-purchase-orders',
  /** 查看分拣记录 */
  PurchaseSortingRecordView = 'supervisor:purchase-order-management:view-sorting-record',
  /** 批量打标 */
  PurchaseBatchTag = 'supervisor:label:batch-add',
  /** 采购单评价 */
  PurchaseEvaluate = 'supervisor:update-evaluate',
  /** 采购单修改备注 */
  PurchaseUpdateRemark = 'supervisor:purchase-order-management:update-purchase-emark',
  /**  ================================ '支付流水 ================================ '*/
  /** 查看付款单 */
  PaymentView = 'supervisor:payment-flow:view-payment-orders',
  /** 核销付款单 */
  PaymentWriteOff = 'supervisor:payment-flow:write-off-payment-orders',
  /** 批量核销 */
  PaymentBatchWriteOff = 'supervisor:payment-flow:batch-write-off-payment-orders',
  /** 批量导出 */
  PaymentBatchExport = 'supervisor:payment-flow:batch-export',
  /** 付款单审核 */
  PaymentOrderAudit = 'supervisor:payment-flow:audit',
  /**  ================================ '申购单管理 ================================ '*/
  /** 查看申购单 */
  PurchaseApplyView = 'supervisor:purchase-request-management:view-request-details',
  /** 关闭申购单 */
  PurchaseAllpyClose = 'supervisor:purchase-request-management:close-purchase-requests',
  /** 批量关闭申购单 */
  PurchaseAllpyBatchClose = 'supervisor:purchase-request-management:batch-close-purchase-requests',
  /** 编辑申购单 */
  PurchaseApplyUpdate = 'supervisor:purchase-request-management:edit-purchase-requests',
  /** 导出申购单 */
  PurchaseApplyExport = 'supervisor:purchase-request-management:export-purchase-requests',
  /** 单个/批量换货 */
  PurchaseApplyChange = 'supervisor:purchase-request-management:exchange-goods',
  /** 单个申购下采购单 */
  PurchaseApplySend = 'supervisor:purchase-request-management:single-request-to-purchase',
  /** 批量申购下采购单 */
  PurchaseApplyBatchSend = 'supervisor:purchase-request-management:batch-create-purchase-orders',
  /** 批量打标 */
  PurchaseApplyBatchTag = 'supervisor:purchase-request-label:batch-add',
  /**  ================================ '申购需求汇总 ================================ '*/
  /** 申购需求汇总列表 */
  PurchaseApplySummaryList = 'supervisor:purchase-request-summary:view-summary-list',
  /** 导出申购需求汇总 */
  PurchaseApplySummaryExport = 'supervisor:purchase-request-summary:export-summary',
  /** 查看申购明细 */
  PurchaseApplySummaryDetail = 'supervisor:purchase-request-summary:view-summary-detail',
  /** 打印申购需求汇总 */
  PurchaseApplySummaryPrint = 'supervisor:purchase-request-summary:view-summary-print',
  /** 批量打印申购需求汇总 */
  PurchaseApplySummaryBatchPrint = 'supervisor:purchase-request-summary:view-summary-batch-print',
  /**  ================================ '对账管理 ================================ '*/
  /** 编辑对账单 */
  ManageStatementEdit = 'supervisor:reconciliation-management:update-statement',
  /** 查看对账单 */
  ManageStatementView = 'supervisor:reconciliation-management:view-reconciliation-statements',
  /** 对账单审核 */
  ManageStatementOrderReview = 'supervisor:reconciliation-management:audit-reconciliation-statements',
  /** 对账单批量审核 */
  ManageStatementOrderBatchReview = 'supervisor:reconciliation-management:batch-audit',
  /** 对账单批量改价 */
  ManageStatementOrderBatchModifyPrice = 'supervisor:reconciliation-management:batch-change-prices',
  /** 对账单付款 */
  ManageStatementPay = 'supervisor:reconciliation-management:reconciliation-statement-payment',
  /** 对账单批量付款 */
  ManageStatementBatchPay = 'supervisor:reconciliation-management:batch-payment',
  /** 对账单批量导出 */
  ManageStatementBatchExport = 'supervisor:reconciliation-management:batch-export',
  /**  ================================ '采购汇总表 ================================ '*/
  /** 批量导出 */
  PurchaseReportBatchExport = 'supervisor:purchase-summary-table:batch-export',
  /**  ================================ '财务汇总表 ================================ '*/
  /** 批量导出 */
  ManageFinancialSummaryBatchExport = 'financialSummary:supervisor-export',

  /**  ================================ '菜谱汇总 ================================ '*/
  /** 菜谱汇总导出 */
  CookbookSummaryExport = 'supervisor:recipe-summary:export-purchase-summary',
  /**  ================================ '菜谱管理 ================================ '*/
  /** 查看菜谱 */
  CookbookView = 'supervisor:recipe-management:view-recipes',
  /** 新建菜谱 */
  CookbookNew = 'supervisor:recipe-management:create-public-recipes',
  /** 编辑菜谱 */
  CookbookEdit = 'supervisor:recipe-management:edit-public-recipes',
  /** 发布菜谱 */
  CookbookPublish = 'supervisor:recipe-management:publish-public-recipes',
  /** 复制菜谱 */
  CookbookCopy = 'supervisor:recipe-management:copy-self-use-recipes',
  /** 删除菜谱 */
  CookbookDelete = 'supervisor:recipe-management:delete-public-recipes',
  /** 关闭菜谱 */
  CookbookClose = 'supervisor:recipe-management:close-public-recipes',
  /** 批量删除 */
  CookbookBatchDelete = 'supervisor:recipe-management:batch-delete',
  /** 批量关闭 */
  CookbookBatchClose = 'supervisor:recipe-management:batch-close',
  /** 批量导出 */
  CookbookBatchExport = 'supervisor:recipe-management:batch-export',
  /**  ================================ '自用菜谱管理 ================================ '*/
  /** 查看菜谱 */
  SelfCookbookView = 'manage:self-menu:detail',
  /** 菜谱导出 */
  SelfCookbookExport = 'manage:self-menu:export',
  /**  ================================ '公告管理 ================================ '*/
  /** 新建公告 */
  NoticeAdd = 'supervisor:announcement-management:create-announcements',
  /** 删除公告 */
  NoticeDelete = 'supervisor:announcement-management:delete-announcements',
  /** 查看公告 */
  NoticeView = 'supervisor:announcement-management:view-announcements',
  /** 编辑公告 */
  NoticeEdit = 'supervisor:announcement-management:edit-announcements',
  /** 批量删除 */
  NoticeBatchDelete = 'supervisor:announcement-management:batch-delete',
  /** 批量发布 */
  NoticeBatchPublish = 'supervisor:announcement-management:batch-publish',
  /** 发布公告 */
  NoticePublish = 'supervisor:announcement-management:publish-announcements',
  /**  ================================ '账户管理 ================================ '*/
  /** 账户调整 */
  AccountAdjustments = 'supervisor:account-management:adjust-accounts',
  /** 查看流水 */
  AccountTurnover = 'supervisor:account-management:view-transaction-flow',
  /** 启用账户 */
  AccountEnable = 'supervisor:account-management:enable-accounts',
  /** 禁用账户 */
  AccountDisable = 'supervisor:account-management:disable-accounts',
  /** 批量调整 */
  AccountBatchAdjustments = 'supervisor:account-management:batch-adjust',
  /** 批量导出 */
  AccountBatchExport = 'supervisor:account-management:batch-export',
  /** 批量启用 */
  AccounttBatchEnable = 'supervisor:account-management:batch-enable',
  /** 批量禁用 */
  AccounttBatchDisable = 'supervisor:account-management:batch-disable',
  /** 设置授信额度 */
  SetCredit = 'supervisor:account-management:set-credit-amount',
  /** 批量设置授信额度 */
  BatchSetCredit = 'supervisor:account-management:batch-set-credit-amount',
  /**  ================================ 开票记录 ================================ */
  /** 查看开票记录 */
  BillRecordView = 'regulator:invoice-record:get-info',
  /** 新建开票记录 */
  BillRecordNew = 'regulator:invoice-record:add',
  /** 编辑开票记录 */
  BillRecordEdit = 'regulator:invoice-record:editing',
  /** 提交开票记录 */
  BillRecordSubmit = 'regulator:invoice-record:submit',
  /** 作废开票记录 */
  BillRecordCancel = 'regulator:invoice-record:nullify',
  /** 删除开票记录 */
  BillRecordDelete = 'regulator:invoice-record:delete',
  /** 批量作废 */
  BillRecordBatchCancel = 'regulator:invoice-record:batch-nullify',
  /** 批量删除 */
  BillRecordBatchDelete = 'regulator:invoice-record:batch-delete',
  /** 批量导出 */
  BillRecordBatchExport = 'regulator:invoice-record:excel',
  /**  ================================ '库存台账 ================================ '*/
  /** 批量导出 */
  InventoryReportBatchExport = 'supervisor:inventory-ledger:batch-export',
  /**  ================================ '实时库存 ================================ '*/
  /** 批量导出 */
  RealTimeInventoryReportBatchExport = 'supervisor:real-time-inventory:batch-export',
  /**  ================================ 投诉建议 ================================ */
  /** 查看投诉建议 */
  SuggestionView = 'supervision:view-demandAccount-records',
  /** 删除投诉建议 */
  SuggestionDelete = 'supervision:delete-demandAccount-records',
  /** 批量删除投诉建议 */
  SuggestionBatchDelete = 'supervision:batch-delete-demandAccount-records',
  /**  ================================ 配送任务 ================================ '*/
  /** 查看配送任务 */
  DeliveryTaskView = 'manager:delivery-management:task-detail',
  /** 一键排线 */
  QuickWiring = 'manager:delivery-management:task-add-plan',
  /** 新增配送任务 */
  DeliveryTaskAdd = 'manager:delivery-management:task-add',
  /** 编辑配送任务 */
  DeliveryTaskEdit = 'manager:delivery-management:task-update',
  /** 完成配送任务 */
  DeliveryTaskFinish = 'manager:delivery-management:task-finish',
  /** 关闭配送任务 */
  DeliveryTaskClose = 'manager:delivery-management:task-close',
  /** 删除配送任务 */
  DeliveryTaskDelete = 'manager:delivery-management:task-delete',
  /** 批量删除 */
  DeliveryTaskBatchDelete = 'manager:delivery-management:task-batch-delete',
  /** 批量关闭 */
  DeliveryTaskBatchClose = 'manager:delivery-management:task-batch-close',
  /** 批量完成 */
  DeliveryTaskBatchFinish = 'manager:delivery-management:task-batch-finish',
  /** 批量打印 */
  DeliveryTaskBatchPrint = 'manager:delivery-management:task-print',

  /**  ================================ 配送路线 ================================ '*/
  /** 查看配送路线 */
  DeliveryLineView = 'manager:delivery-management:line-detail',
  /** 新增配送路线 */
  DeliveryLineAdd = 'manager:delivery-management:line-add',
  /** 编辑配送路线 */
  DeliveryLineEdit = 'manager:delivery-management:line-update',
  /** 删除配送路线 */
  DeliveryLineDelete = 'manager:delivery-management:line-delete',
  /** 批量删除配送路线 */
  DeliveryLineBatchDelete = 'manager:delivery-management:line-batch-delete',

  /**  ================================ 司机管理 ================================ '*/
  /** 新增司机 */
  DriverAdd = 'manager:delivery-management:diver-add',
  /** 编辑司机 */
  DriverEdit = 'manager:delivery-management:diver-update',
  /** 删除司机 */
  DriverDelete = 'manager:delivery-management:diver-delete',
  /** 批量删除司机 */
  DriverBatchDelete = 'manager:delivery-management:diver-batch-delete',
  /**  ================================ 车辆 ================================ '*/
  /** 查看车辆列表 */
  CarView = 'manag:car-list',
  /** 新建车辆 */
  CarCreate = 'manag:car-add',
  /** 编辑车辆 */
  CarEdit = 'manag:car-update',
  /** 删除车辆 */
  CarDelete = 'manag:car-delete',
  /** 批量删除 */
  CarBatchDelete = 'manag:car-batch-delete',

  /**  ================================ 周转筐记录 ================================ */
  /** 查看周转筐记录 */
  TurnoverBasketRecordView = 'manage:turnover-basket:detail',
  /** 新增周转筐记录 */
  TurnoverBasketRecordAdd = 'manage:turnover-basket:add',
  /** 编辑周转筐记录 */
  TurnoverBasketRecordEdit = 'manage:turnover-basket:update',
  /** 提交周转筐记录 */
  TurnoverBasketRecordSubmit = 'manage:turnover-basket:finish',
  /** 关闭周转筐记录 */
  TurnoverBasketRecordClose = 'manage:turnover-basket:close',
  /** 删除周转筐记录 */
  TurnoverBasketRecordDelete = 'manage:turnover-basket:delete',
  /** 周转筐管理 */
  TurnoverBasketManage = 'manage:turnover-basket:manage',
  /** 批量删除周转筐记录 */
  TurnoverBasketRecordBatchDelete = 'manage:turnover-basket:batch-delete',
  /** 批量关闭周转筐记录 */
  TurnoverBasketRecordBatchClose = 'manage:turnover-basket:batch-close',

  /**  ================================ 周转筐统计 ================================ */
  /** 周转筐统计批量导出 */
  TurnoverBasketStatisticsBatchExport = 'demand:turnover-basket:statistic',

  /**  ================================ 限价管理 ================================ */
  /** 查看监管商品 */
  LimitPriceProductView = 'manage:price-limit:list',
  /** 设置标准价 */
  LimitPriceSetStandardPrice = 'manage:price-limit:change',
  /** 折扣率管理 */
  LimitPriceDiscountRateManage = 'manage:price-limit:quotation',
  /** 批量导入 */
  LimitPriceBatchImport = 'manage:price-limit:import',
  /** 批量导出 */
  LimitPriceBatchExport = 'manage:price-limit:export',

  /**  ================================ 报餐记录 ================================ */
  /** 报餐记录列表 */
  MealRecordList = 'manage:menu-record:list',
  /** 查看报餐记录 */
  MealRecordView = 'manage:menu-record:view',
  /** 新增报餐记录 */
  MealRecordAdd = 'manage:menu-record:add',
  /** 提交报餐记录 */
  MealRecordSubmit = 'manage:menu-record:apply',
  /** 编辑报餐记录 */
  MealRecordEdit = 'manage:menu-record:edit',
  /** 关闭报餐记录 */
  MealRecordClose = 'manage:menu-record:close',
  /** 删除报餐记录 */
  MealRecordDelete = 'manage:menu-record:deleted',
  /** 批量导出 */
  MealRecordBatchExport = 'manage:menu-record:export',
  /** 同步缴费人数 */
  MealRecordSyncPay = 'manage:menu-record:slip-count',
  /** 同步请假人数 */
  MealRecordSyncLeave = 'manage:menu-record:leava-count',
  /** 批量提交报餐记录 */
  MealRecordBatchSubmit = 'manage:menu-record:batch-apply',
  /** 批量关闭报餐记录 */
  MealRecordBatchClose = 'manage:menu-record:batch-close',
  /** 批量删除报餐记录 */
  MealRecordBatchDelete = 'manage:menu-record:batch-deleted',
  /**  ================================ 餐标管理 ================================ */
  /** 餐标管理列表 */
  MealStandardList = 'manage:menu-label:list',
  /** 新建餐标 */
  MealStandardAdd = 'manage:menu-label:add',
  /** 编辑餐标 */
  MealStandardEdit = 'manage:menu-label:edit',
  /** 启用餐标 */
  MealStandardEnable = 'manage:menu-label:start',
  /** 禁用餐标 */
  MealStandardDisable = 'manage:menu-label:stop',
  /** 删除餐标 */
  MealStandardDelete = 'manage:menu-label:deleted',
  /** 批量启用 */
  MealStandardBatchEnable = 'manage:menu-label:batch-start',
  /** 批量禁用 */
  MealStandardBatchDisable = 'manage:menu-label:batch-stop',
  /** 批量删除 */
  MealStandardBatchDelete = 'manage:menu-label:batch-deleted',
  /**  ================================ 报餐汇总 ================================ */
  /** 报餐汇总列表 */
  MealSummaryList = 'manage:menu-label-summary:list',
  /** 报餐汇总导出 */
  MealSummaryExport = 'manage:menu-label-summary:batch-export',
  /**  ================================ 套餐需求汇总 ================================ */
  /** 套餐需求汇总列表 */
  PackageSummaryList = 'manage:menu-record-summary:list',
  /** 套餐需求汇总导出 */
  PackageSummaryExport = 'manage:menu-record-summary:export',
  /**  ================================ 标签管理 ================================ */
  /** 标签管理列表 */
  TagManageList = 'supervisor:label-list',
  /** 新建标签 */
  TagManageAdd = 'supervisor:label-add',
  /** 编辑标签 */
  TagManageEdit = 'supervisor:label-update',
  /** 标签详情 */
  TagManageDetail = 'supervisor:label-detail',
  /** 删除标签 */
  TagManageDelete = 'supervisor:label-delete',
  /** 批量删除标签 */
  TagManageBatchDelete = 'supervisor:label-batch-delete',
  /**  ================================ 统一定价 ================================ */
  /** 统一定价列表 */
  UniformPriceList = 'regulator:uniform-pricing:list',
  /** 设置统一价格 */
  UniformPriceSet = 'regulator:uniform-pricing:standard-price-chang',
  /** 导入统一定价 */
  UniformPriceImport = 'regulator:uniform-pricing:import',
  /** 导出统一定价 */
  UniformPriceExport = 'regulator:uniform-pricing:export',
  /**  ================================ 新品提报 ================================ */
  /** 新品提报列表 */
  NewSubmissionList = 'regulator:product-report:list',
  /** 编辑新品提报 */
  NewSubmissionEdit = 'regulator:product-report:update',
  /** 删除新品提报 */
  NewSubmissionDelete = 'regulator:product-report:delete',
  /** 转商品 */
  NewSubmissionToCommodity = 'regulator:product-report:cover-product',
  /**  ================================ 自动化 ================================ */
  /** 自动化列表 */
  AutomationList = 'manage:taskAutomation:taskAutomation-queryList',
  /** 启用自动化 */
  AutomationEnable = 'manage:taskAutomation:taskAutomation-updateInfo-enable',
  /** 禁用自动化 */
  AutomationDisable = 'manage:taskAutomation:taskAutomation-updateInfo-disable',
  /**  ================================ 滞销品 ================================ */
  /** 滞销品列表 */
  DeadStockList = 'supervision:unsoldProduct:query-list',
  /** 滞销品规则设置 */
  DeadStockRuleSet = 'supervision:unsoldProduct:update-category-unsold-days',
  /** 批量导出 */
  DeadStockBatchExport = 'supervision:unsoldProduct:export-unsold-product',
  /**  ================================ 晨检记录 ================================ */
  /** 晨检记录列表 */
  MorningCheckList = 'supervision:morningInspection:queryList',
  /** 晨检记录详情 */
  MorningCheckView = 'supervision:morningInspection:getInfo',
  /**  ================================ 消杀记录 ================================ */
  /** 消杀记录列表 */
  DisinfectList = 'supervisor:disinfect-manage:list',
  /** 消杀记录详情 */
  DisinfectView = 'supervisor:disinfect-manage:detail',
  /**  ================================ 留样 ================================ */
  /** 留样列表 */
  KeepSampleList = 'regulator:sample:order:query:list',
  /** 留样详情 */
  KeepSampleView = 'regulator:sample:order:query:page',
  /**  ================================ 巡检任务 ================================ */
  /** 巡检任务列表 */
  InspectionTaskList = 'regulator:inspectionTaskList:list',
  /** 巡检任务详情 */
  InspectionTaskView = 'regulator:inspectionTaskList:page',
  /**  ================================ 陪餐 ================================ */
  /** 陪餐记录列表 */
  AccompanyList = 'regulator:meal_accompaniment_record:list',
  /** 查看陪餐记录 */
  AccompanyView = 'regulator:meal_accompaniment_record:page',
  /**  ================================ 项目 ================================ */
  /** 项目列表 */
  ProjectList = 'manage:project:list',
  /** 新建项目 */
  ProjectAdd = 'manage:project:add',
  /** 查看项目 */
  ProjectDetail = 'manage:project:detail',
  /** 编辑项目 */
  ProjectEdit = 'manage:project:update',
  /** 发布项目 */
  ProjectPublish = 'manage:project:publish',
  /** 公示项目 */
  ProjectPublic = 'manage:project:publicty',
  /** 取消公示项目 */
  ProjectCancelPublic = 'manage:project:no-publicty',
  /** 评标定标 */
  ProjectEvaluate = 'manage:project:eval',
  /** 复制项目 */
  ProjectCopy = 'manage:project:copy',
  /** 关闭项目 */
  ProjectClose = 'manage:project:close',
  /** 删除项目 */
  ProjectDelete = 'manage:project:delete',
  /** 批量发布 */
  ProjectBatchPublish = 'manage:project:batch-publish',
  /** 批量公示 */
  ProjectBatchPublic = 'manage:project:batch-publicty',
  /** 批量取消公示 */
  ProjectBatchCancelPublic = 'manage:project:batch-no-publicty',
  /** 批量关闭 */
  ProjectBatchClose = 'manage:project:batch-close',
  /** 批量删除 */
  ProjectBatchDelete = 'manage:project:batch-deleted',
  /**  ================================ 缴费单 ================================ */
  /** 缴费单查看列表 */
  PaymentReceiptList = 'manage:payment-slip:list',
  /** 缴费单查看 */
  PaymentReceiptView = 'manage:payment-slip:page',
  /** 缴费单新建 */
  PaymentReceiptCreate = 'manage:payment-slip:add',
  /** 缴费单编辑 */
  PaymentReceiptEdit = 'manage:payment-slip:update',
  /** 缴费单发布 */
  PaymentReceiptPublish = 'manage:payment-slip:public',
  /** 缴费单关闭 */
  PaymentReceiptClose = 'manage:payment-slip:close',
  /** 缴费单删除 */
  PaymentReceiptDelect = 'manage:payment-slip:delete',
  /** 缴费单批量导出 */
  PaymentReceiptBatchExport = 'manage:payment-slip:export',
  /** 缴费单批量发布 */
  PaymentReceiptBatchPublish = 'manage:payment-slip:batch-public',
  /** 缴费单批量关闭 */
  PaymentReceiptBatchClose = 'manage:payment-slip:batch-close',
  /** 缴费单批量删除 */
  PaymentReceiptBatchDelect = 'manage:payment-slip:batch-delete',
  /**  ================================ 缴费记录 ================================ */
  /** 缴费记录查看列表 */
  PaymentRecordsList = 'manage:payment-slip-record:list',
  /** 缴费记录查看 */
  PaymentRecordsView = 'manage:payment-slip-record:page',
  /** 缴费记录新建 */
  PaymentRecordsCreate = 'manage:payment-slip-record:add',
  /** 缴费记录编辑 */
  PaymentRecordsEdit = 'manage:payment-slip-record:update',
  /** 缴费记录请假 */
  PaymentRecordsAskForLeave = 'manage:payment-slip-record:askForLeave',
  /** 缴费记录删除 */
  PaymentRecordsDelect = 'manage:payment-slip-record:delete',
  /** 缴费记录批量导入 */
  PaymentRecordsBatchImport = 'manage:payment-slip-record:import',
  /** 缴费记录批量导出 */
  PaymentRecordsBatchExport = 'manage:payment-slip-record:export',
  /** 缴费记录批量删除 */
  PaymentRecordsBatchDelect = 'manage:payment-slip-record:batchDelete',
  /**  ================================ 餐费汇总 ================================ */
  /** 餐费汇总查看列表 */
  AccompanySummaryList = 'regulator:summary-meal:list',
  /** 餐费汇总批量导出 */
  AccompanySummaryBatchExport = 'regulator:summary-meal:export',
  /**  ================================ 违规记录 ================================ */
  /** 违规记录列表 */
  ViolationList = 'manage:violation-record:list',
  /** 删除违规记录 */
  ViolationDelete = 'manage:violation-record:delete',
  /** 批量删除 */
  ViolationBatchDelete = 'manage:violation-record:batch-delete',
  /**  ================================ 就餐日历 ================================ */
  /** 就餐日历列表 */
  DiningCalendarList = 'manage:/dining-calender/list',
  /** 就餐日历导出 */
  DiningCalendarExport = 'manage:/dining-calender/export',
  /**  ================================ 采购需求汇总 ================================ */
  /** 采购需求汇总查看列表 */
  PurchaseSummaryList = 'manage:purchase-summary:list',
  /** 采购需求汇总查看明细 */
  PurchaseSummaryDetail = 'manage:purchase-summary:detail',
  /** 采购需求汇总打印 */
  PurchaseSummaryPrint = 'manage:purchase-summary:print',
  /** 采购需求汇总批量导出 */
  PurchaseSummaryBatchExport = 'manage:purchase-summary:batch-export',
  /** 采购需求汇总批量打印 */
  PurchaseSummaryBatchPrint = 'manage:purchase-summary:batch-print',
  /**  ================================ 售后单 ================================ */
  /** 售后单查看列表 */
  AfterSalesList = 'manage:after-sale:list',
  /** 售后单查看明细 */
  AfterSalesDetail = 'manage:after-sale:page',
  /** 售后单新建 */
  AfterSalesCreate = 'manage:after-sale:add',
  /** 售后单编辑 */
  AfterSalesEdit = 'manage:after-sale:update',
  /** 售后单审核 */
  AfterSalesReview = 'manage:after-sale:check',
  /** 查看退货记录 */
  AfterSalesReturn = 'manage:after-sale:return-record',
  /** 查看验收记录 */
  AfterSalesCheck = 'manage:after-sale:acceptance-record',
  /** 售后单关闭 */
  AfterSalesClose = 'manage:after-sale:close',
  /** 售后单删除 */
  AfterSalesDelete = 'manage:after-sale:delete',
  /** 售后单批量导出 */
  AfterSalesBatchExport = 'manage:after-sale:batch-export',
  /** 售后单批量关闭 */
  AfterSalesBatchClose = 'manage:after-sale:batch-close',
  /** 售后单批量删除 */
  AfterSalesBatchDelete = 'manage:after-sale:batch-delete',

  /**  ================================ 商品行情价 ================================ */
  /** 商品行情价查看列表 */
  MarketPriceList = 'supervision:market-price:list',
  /** 商品行情价查看明细 */
  MarketPriceDetail = 'supervision:market-price:get-info',
  /** 商品行情价新建 */
  MarketPriceCreate = 'supervision:market-price:add',
  /** 商品行情价编辑 */
  MarketPriceEdit = 'supervision:market-price:editor',
  /** 商品行情价发布 */
  MarketPricePublish = 'supervision:market-price:publish',
  /** 复制商品行情价 */
  MarketPriceCopy = 'supervision:market-price:copy',
  /** 删除商品行情价 */
  MarketPriceDelete = 'supervision:market-price:delete',
  /** 商品行情价批量发布 */
  MarketPriceBtachPublish = 'supervision:market-price:batch-publish',
  /** 商品行情价批量删除 */
  MarketPriceBacthDelete = 'supervision:market-price:batch-delete',
  /** 同步商品行情价 */
  MarketPriceSync = 'supervision:market-price:synchronous-price',
  /**  ================================ 折扣定价 ================================ */
  /** 折扣定价查看列表 */
  DiscountPriceList = 'supervision:discounted-pricing:list',
  /** 折扣定价查看明细 */
  DiscountPriceDetail = 'supervision:discounted-pricing:get-info',
  /** 折扣定价新建 */
  DiscountPriceCreate = 'supervision:discounted-pricing:add',
  /** 折扣定价编辑 */
  DiscountPriceEdit = 'supervision:discounted-pricing:editor',
  /** 折扣定价发布 */
  DiscountPricePublish = 'supervision:discounted-pricing:publish',
  /** 折扣定价中止 */
  DiscountPriceStop = 'supervision:discounted-pricing:terminate',
  /** 折扣定价延期 */
  DiscountPriceExtension = 'supervision:discounted-pricing:extension',
  /** 折扣定价公示 */
  DiscountPricePublic = 'supervision:discounted-pricing:public',
  /** 折扣定价取消公示 */
  DiscountPriceCancelPublic = 'supervision:discounted-pricing:cancel-public',
  /** 折扣定价比价定价 */
  DiscountPriceCompare = 'supervision:discounted-pricing:comparison-pricing',
  /** 折扣定价生成采购合同 */
  DiscountPricePact = 'supervision:discounted-pricing:add-pact',
  /** 折扣定价复制 */
  DiscountPriceCopy = 'supervision:discounted-pricing:copy',
  /** 折扣定价关闭 */
  DiscountPriceClose = 'supervision:discounted-pricing:close',
  /** 折扣定价删除 */
  DiscountPriceDelete = 'supervision:discounted-pricing:delete',
  /** 折扣定价批量发布 */
  DiscountPriceBatchPublish = 'supervision:discounted-pricing:batch-publish',
  /** 折扣定价批量中止 */
  DiscountPriceBatchStop = 'supervision:discounted-pricing:batch-terminate',
  /** 折扣定价批量延期 */
  DiscountPriceBacthExtension = 'supervision:discounted-pricing:batch-extension',
  /** 折扣定价批量公示 */
  DiscountPriceBatchPublic = 'supervision:discounted-pricing:batch-public',
  /** 折扣定价批量取消公示 */
  DiscountPriceBatchCancelPublic = 'supervision:discounted-pricing:batch-cancel-public',
  /** 折扣定价批量关闭 */
  DiscountPriceBatchClose = 'supervision:discounted-pricing:batch-close',
  /** 折扣定价批量删除 */
  DiscountPriceBatchDelete = 'supervision:discounted-pricing:batch-delete',
  /**  ================================ 需方画像 ================================ */
  /** 需方画像 */
  PurchaserPortraitList = 'manage:demand-portrait:list',
  /** 需方画像导出 */
  PurchaserPortraitExport = 'manage:demand-portrait:batch-export',
  /**  ================================ 采购商品备注 ================================ */
  /** 采购商品备注列表 */
  PurchaseSkuRemarkList = 'manage:produc-remark:list',
  /** 采购商品备注导出 */
  PurchaseSkuRemarkExport = 'manage:produc-remark:batch-export',
  /** 采购商品备注编辑 */
  PurchaseSkuRemarkEdit = 'manage:produc-remark:batch-setting',
  /**  ================================ 食安统计表 ================================ */
  /** 食安统计表 */
  FoodSafetyReportList = 'manage:report-summary:shian-list',
  /** 食安统计表导出 */
  FoodSafetyReportExport = 'manage:report-summary:shian-export',
  /**  ================================ 司机绩效 ================================ */
  /** 司机绩效列表 */
  DriverPerformanceList = 'manage:delivery-performance:list',
  /** 司机绩效导出 */
  DriverPerformanceExport = 'manage:delivery-performance:batch-export',
  /**  ================================ 需方组汇总表 ================================ */
  /** 需方组汇总表  */
  PurchaseGroupSummaryList = 'manage:demand-summary:list',
  /** 批量导出 */
  PurchaseGroupSummaryBatchExport = 'manage:demand-summary:export',
  /**  ================================ 现场监控违规记录 ================================ */
  /** 违规记录列表 */
  ViolationRecordList = 'manage:violation-record:supplier-list',
  /** 违规记录删除 */
  ViolationRecordDelete = 'manage:violation-record:supplier-delete',
  /** 违规记录批量删除 */
  ViolationRecordBatchDelete = 'manage:violation-record:supplier-batch-delete',
}
